import React, { FC, useState, useEffect } from 'react'
import { observer } from 'mobx-react'
import { RouteComponentProps } from 'react-router-dom'
import { IonPage, IonContent, useIonViewWillEnter, useIonViewDidLeave } from '@ionic/react'
import { UseHeader, CouponItem, ResultAlert, MktLoading, MktEmpty } from '@cps'
import { memberMobx, activityMobx } from '@mobxStore'
import ActivityApi from '@api/activity.api'
import { modalLayer, useHistoryNew, getCouponsInfo, getPlatform } from '@utils'
import mktController from 'controllers/mktController'
import { keyBy } from '@dt/fe-utils/dist/lodash'
import i18n from 'i18next'
import { FixBackHeader, NoticeModal } from '@pages/mkt/components'
import ActivityDetail from '../../components/activityDetail'
import Coupons from '../components/Coupons'
import './index.scss'

const { isWeixinMiniProgram } = getPlatform()

interface IProps extends IPage, RouteComponentProps { }

const CouponsSend: FC<IProps> = ({ match }) => {
  const { activityId } = match.params as any
  const history = useHistoryNew()
  const [activeStatus, setActiveStatus] = useState<boolean>(true)
  const [activeInfo, setActiveInfo] = useState<any>({})
  const [couponDetails, setCouponDetails] = useState<any>({})
  const [showLoading, setShowLoading] = useState<boolean>(true)
  const [invitedNums, setInvitedNums] = useState<number>(0)
  const { memberInfo } = memberMobx
  const { getActiveDetail } = activityMobx
  // Component Event
  const onBack = () => {
    mktController.goBack(history)
  }
  const showReward = (couponList: any) => {
    modalLayer(ResultAlert, {
      title: i18n.t('mkt.activity.rewards'),
      btnTitle: i18n.t('pay.acknowledged'),
      children: couponList.map((item: any, index: number) => {
        const hasItem: any = couponDetails[item.couponId]
        return hasItem && (
          <div className='coupon-block' key={`${index}-${item.couponId}`}>
            <CouponItem type='get' couponInfo={hasItem} cnt={item.couponCnt > 1 ? item.couponCnt : ''}></CouponItem>
          </div>)
      })
    }).then(() => { }, () => { })
  }
  const goShare = () => {
    mktController.checkLogin(history).then(() => {
      const shareInfo: any = {
        memberId: memberInfo.memberId || 0,
        activityId: activityId
      }
      const url = `${location.origin}/activity/couponsGet/${activityId}${location.search}&shareInfo=${encodeURIComponent(JSON.stringify(shareInfo))}`
      mktController.shareUrl(url)
    })
  }
  // Data Method
  const getActiveData = () => {
    getActiveDetail(activityId).then((res: any) => {
      setShowLoading(false)
      if (res) {
        setActiveInfo(res)
        if (res?.isOver) {
          setActiveStatus(false)
        } else {
          transCoupons(res.extra.rewardCoupons.concat(res.coupons))
        }
      } else {
        setActiveStatus(false)
      }
    })
  }
  const transCoupons = (list: any) => {
    ActivityApi.getCouponsList({ couponIds: list.map(item => item.couponId) }).then((coupon: any) => {
      if (coupon?.length > 0) {
        setCouponDetails(keyBy(coupon, 'couponId'))
      }
    })
  }
  const getRule = () => {
    modalLayer(ActivityDetail, {
      children: (
        <>
          {activeInfo.extra.copywriting && (
            <div>
              <div className='detail-des'>
                <div className='title'>{i18n.t('mkt.activity.introduce')}</div>
                <div className='des'>{activeInfo.extra.copywriting}</div>
              </div>
              <div className='detail-des space-between' onClick={() => history.push(`/activity/myPrize/${activityId}`)}>
                <div className='title'>{i18n.t('mkt.activity.myPrize')}</div>
                <div className='des'><i className='iconfont icon-chevron-right' /></div>
              </div>
              <div className='detail-des space-between' onClick={() => history.push(`/activity/invitedMember/${activityId}`)}>
                <div className='title'>{i18n.t('mkt.activity.invitationNum')}</div>
                <div className='des'><i className='iconfont icon-chevron-right' /></div>
              </div>
            </div>
          )}
        </>
      )
    }).then(() => { }, () => { })
  }
  // Component Effect
  useIonViewWillEnter(() => {
    setShowLoading(true)
    getActiveData()
  })
  useIonViewDidLeave(() => {
    setShowLoading(false)
  }, [])
  useEffect(() => {
    ActivityApi.invitationMemberList({ brandId: memberMobx.brandId, activityId }).then((res) => {
      setInvitedNums(res?.length || 0)
      if (res.length && res.length % activeInfo.extra?.invitationNum === 0) {
        modalLayer(NoticeModal, {
          title: i18n.t('mkt.coupon.receivedNotice'),
          des: i18n.t('mkt.coupon.inviteSuccDes', { num: res.length })
        }).then(() => {}, () => {})
      }
    })
  }, [activeInfo])
  useEffect(() => {
    if (Object.keys(activeInfo).length !== 0 && memberMobx.isLogin && memberMobx.memberInfo.type === 'member') {
      const shareInfo: any = {
        memberId: memberInfo.memberId || 0,
        activityId: activityId
      }
      let url = `${location.origin}/activity/couponsGet/${activityId}?ct=brand&b=${Config.BRANDID}&shareInfo=${encodeURIComponent(JSON.stringify(shareInfo))}`
      if (isWeixinMiniProgram) {
        url = `/pages/launch/index?jumpH5Page=${encodeURIComponent(url)}&shareInfo=${encodeURIComponent(JSON.stringify(shareInfo))}`
      }
      mktController.initShareData({
        url: url,
        title: activeInfo.activityName,
        des: activeInfo.extra?.copywriting,
        img: activeInfo.playbill
      })
    }
  }, [activeInfo, memberMobx.isLogin, memberMobx.memberInfo])
  return (
    <IonPage className='coupon-send-page'>
      {
        activeStatus ? <FixBackHeader text={i18n.t('mkt.market.marketDetail')} onClick={getRule} /> : <UseHeader title={activeInfo.activityName} onBack={onBack} />
      }
      <IonContent className='page-content'>
        {showLoading && <MktLoading></MktLoading>}
        <div className='page-body'>
          {
            activeStatus ? (
              <div>
                <img className='activity-img' src={activeInfo.playbill} />
                <div className='activity-info'>
                  <div className='activity-block'>
                    <Coupons
                      shareText={
                        invitedNums === 0
                          ? i18n.t('mkt.activity.shareContnet', { num: `<span style='color: #E50E2B'>${activeInfo.extra?.invitationNum || 0}</span>` })
                          : i18n.t('mkt.activity.againShareContnet', { num: `<span style='color: #E50E2B'>${(activeInfo.extra?.invitationNum - invitedNums % activeInfo.extra?.invitationNum) || 0}</span>` })
                      }
                      coupons={activeInfo.extra?.rewardCoupons || []}
                      couponDetails={couponDetails}
                      count={getCouponsInfo(activeInfo.extra?.rewardCoupons || [], 'cnt', couponDetails)}
                      onClick={goShare}
                      title={i18n.t('mkt.activity.shareNow')}
                    >
                    </Coupons>
                    {/* <div className='prize-invite'>
                      <div className='btn' onClick={() => history.push(`/activity/myPrize/${activityId}`)}>
                        <i className='iconfont icon-gift'></i>
                        <span className='text'>{i18n.t('mkt.activity.myPrize')}</span>
                      </div>
                      <div className='btn' onClick={() => history.push(`/activity/invitedMember/${activityId}`)}>
                        <i className='iconfont icon-person'></i>
                        <i className='iconfont icon-person'></i>
                        <span>{i18n.t('mkt.activity.invitationNum')}</span>
                      </div>
                    </div> */}
                  </div>
                  {/* {
                    activeInfo.extra &&
                      <>
                        <div className='detail-title'><EventDetailsTitle title={i18n.t('mkt.activity.introduce')} /></div>
                        <div className='des-text'>
                          <div className='title'>{i18n.t('mkt.activity.procedure')}</div>
                          <div className='text'>{i18n.t('mkt.activity.procedure1')}</div>
                          <div className='text'>{i18n.t('mkt.activity.procedure2')}</div>
                          <div className='tip' onClick={() => showReward(activeInfo.coupons)}>{i18n.t('mkt.activity.rewardDetail')}</div>
                          <div className='text'>{i18n.t(`mkt.activity.${activeInfo.extra.invitationType}Reward`, { num: activeInfo.extra.invitationNum })}</div>
                          <div className='tip' onClick={() => showReward(activeInfo.extra?.rewardCoupons)}>{i18n.t('mkt.activity.rewardDetail')}</div>
                          <div>
                            <span className='title'>{i18n.t('mkt.activity.activityTimes')}: </span>
                            <span className='text'>{format.toMonthDateYear(activeInfo.startTime)} ~ {format.toMonthDateYear(activeInfo.endTime)}</span>
                          </div>
                          <div className='title'>{i18n.t('mkt.activity.statement', { brand: storeMobx.brand.brandName })}</div>
                        </div>
                      </>
                  } */}
                </div>
              </div>
            ) : (
              <div className='activity-end'>
                <MktEmpty type='end' text={activeInfo?.activityId ? i18n.t('mkt.market.eventIsOver') : i18n.t('mkt.market.activityNotExist')}></MktEmpty>
              </div>
            )
          }
        </div>
      </IonContent>
    </IonPage>
  )
}

export default observer(CouponsSend)
